/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Header.css";
import { AuthConsumer } from "../../../AuthContext";
import plugLogo from "../../../assets/component/images/plug-impact-withText.png";

// Workspace top bar: the wordmark, search (for everyone but a nonprofit), and
// the one number that matters to this account type. It sticks to the top while
// the workspace scrolls.
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { searchFocused: false };
  }

  // Opening the search bar is also a request to go where results are shown.
  focusSearch = () => {
    this.setState({ searchFocused: true });
    if (this.props.vm.onSearchActive) {
      this.props.vm.onSearchActive();
    }
  };

  blurSearch = () => this.setState({ searchFocused: false });

  render() {
    const vm = this.props.vm;
    // Collapsed to a circular icon button until focused (or while it holds a query).
    const searchOpen = this.state.searchFocused || !!vm.query;
    return (
      <div className="Marketplace-Header">
        <div className="Marketplace-Header-logo" onClick={vm.goBrowse}>
          <img src={plugLogo} alt="Plug" className="Marketplace-Header-logoImg" />
          <span className="Marketplace-Header-beta">{vm.m.beta}</span>
        </div>
        <div className="Marketplace-Header-actions">
          {vm.showSearch && (
            <div className={"Marketplace-Header-search" + (searchOpen ? " Marketplace-Header-search--open" : "")}>
              <input
                placeholder={searchOpen ? vm.searchPlaceholder : ""}
                value={vm.query}
                onChange={vm.onQuery}
                onFocus={this.focusSearch}
                onBlur={this.blurSearch}
                className="Marketplace-Header-searchInput"
                data-testid="marketplace-header-search"
              />
              <span className="Marketplace-Header-searchIconRing" />
              <span className="Marketplace-Header-searchIconHandle" />
            </div>
          )}

          <div className="Marketplace-Header-headline" onClick={vm.headlineGo}>
            <span className="Marketplace-Header-headlineValue">{vm.headlineValue}</span>
            <span className="Marketplace-Header-headlineCaption">{vm.headlineCaption}</span>
          </div>

          {/* HomePageRoute redirects /En <-> /Zh <-> /Cn off i18n.language, so
              changing it here is enough to move the marketplace between locales. */}
          <AuthConsumer>
            {({ i18n }) => (
              <div className="Marketplace-Header-lang">
                <div className="Marketplace-Header-langGlobe" />
                <select
                  className="Marketplace-Header-langSelect"
                  value={i18n.language}
                  onChange={(e) => i18n.changeLanguage(e.target.value)}
                >
                  <option value="zh">繁體中文</option>
                  <option value="cn">简体中文</option>
                  <option value="en">English</option>
                </select>
              </div>
            )}
          </AuthConsumer>

          {/* One button, no account tile. The avatar and the name beside it
              said nothing the workspace itself does not already say — signed
              out the circle was empty and the label promised an account the
              visitor did not have, and signed in it named the organisation
              whose pages fill the screen. vm.avatar and vm.accountLabel are
              still built, so restoring the tile is markup only. */}
          <AuthConsumer>
            {({ isAuth, isOrgAuth, logout }) => (
              <div className="Marketplace-Header-account">
                {isAuth || isOrgAuth ? (
                  <div className="Marketplace-Header-logoutBtn" onClick={() => vm.logOut(logout)}>
                    {vm.m.loginLogOut}
                  </div>
                ) : (
                  <div className="Marketplace-Header-loginBtn" onClick={vm.goLogin}>
                    {vm.m.logIn}
                  </div>
                )}
              </div>
            )}
          </AuthConsumer>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default Header;
